export default {"src":"/_next/static/media/apples.9d5ca570.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};